import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setDeletePredictionSet](state, action) {
      return action.payload
    },
    [rawActions.deletePredictionSet.request](state, action) {
      return null
    },
    [rawActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
